import * as pageActions from './pageActions';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
import { fetchMapConfig, getOverallMapTabs } from '../utils/mapConfigTabs';


export const initPageOverallMap = () => dispatch => {
  dispatch(pageActions.loadPageStart());
  return Promise.all([
    apiActions.loadEndpoint(apiValues.nref.program.endpoint, null),
    fetchMapConfig(),
  ])
    .then(([results, config]) => {
      let program = apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.program.fieldsUsed);
      program.forEach(p => {
        p.project = p.project ? apiActions.arraySelectCamelCaseKeys(p.project, apiValues.nref.project.fieldsUsed).filter(project => {
          return !project.softDelete;
        }) : null;
      });

      return {
        program,
        mapTabs: getOverallMapTabs(config.layerGroups),
      };
    })
    .then(page => dispatch(pageActions.loadPageSuccess(page)))
    .catch(error => {
      console.error(error);
      dispatch(pageActions.loadPageFail(error));
      throw error;
    });
};
